export default {"src":"/_next/static/media/box-bottom.bc590abd.svg","height":140,"width":210,"blurWidth":0,"blurHeight":0};